import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';

const PercentageEditor = forwardRef((props, ref) => {

  const [value, setValue] = useState(Number(props.value) * 100);
  const refInput = useRef(null);

  useEffect(() => {
    refInput.current.focus();
  });

  useImperativeHandle(ref, () => ({
    getValue: () => isNaN(value) ? null : value / 100,
    isCancelBeforeStart: () => false,
    isCancelAfterEnd: () => false,
  }));

  return (
    <input
      ref={refInput}
      defaultValue={value}
      onChange={event => setValue(event.target.value ? Number(event.target.value) : null)}
      style={{width: "100%"}}
    />
  );

});

export default PercentageEditor;
